import { ChangeEvent, FC, memo } from 'react'

import { ChoiceOption } from 'ui/types'

import { RadioButton } from './RadioButton'
import { RadioGroupOrientation } from './RadioGroupOrientation'
import { RadioGroupProps } from './RadioGroupProps'

import * as SC from './styles'

const YES_NO = [
  {
    label: 'Yes',
    value: true
  },
  {
    label: 'No',
    value: false
  }
]

export const RadioGroup: FC<RadioGroupProps> = memo((props) => {
  const {
    value,
    onChange,
    required = false,
    data,
    name,
    disabled = false,
    hint,
    valueType,
    orientation = RadioGroupOrientation.HORIZONTAL,
    'data-qa': dataQa,
    readonly = false,
    error,
    yesNo = false
  } = props

  let parsedData: ChoiceOption[] | undefined = undefined

  if (yesNo) {
    parsedData = YES_NO
  } else {
    parsedData = data
  }

  if (!parsedData) {
    throw new Error('Data property must be set')
  } else if (parsedData.length <= 1) {
    throw new Error('Must be at least 2 options in RadioGroup')
  }

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    let newVal
    // support init value as null
    const parseValueType = valueType || typeof value
    // Convert return value to initial type
    switch (parseValueType) {
      case 'boolean':
        newVal = JSON.parse(e.target.value)
        break
      case 'number':
        newVal = +e.target.value
        break
      default:
        newVal = e.target.value
        break
    }

    if (onChange) {
      onChange(newVal, undefined)
    }
    e.stopPropagation()
  }

  // Readonly is always disabled
  const isDisabled = readonly ? true : disabled ? true : false

  return (
    <>
      <SC.RadioGroupContainer orientation={orientation}>
        {parsedData.map((item, index) => (
          <RadioButton
            key={index}
            readonly={readonly}
            dataQa={dataQa}
            disabled={isDisabled}
            error={error}
            required={required && index === 0}
            name={name}
            checked={value === item.value}
            value={item.value}
            label={item.label}
            onChange={handleChange}
          />
        ))}
      </SC.RadioGroupContainer>
      {hint && <SC.Hint disabled={disabled}>{hint}</SC.Hint>}
    </>
  )
})
